module.exports = __webpack_public_path__ + "static/media/doctor-04.b5ab9f43.jpg";